import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { EinreichungStep } from '@ebeihilfe/einreichung-old';
import { AntragsLimitService } from '@ebeihilfe/einreichung-shared/services';
import { CircleWithSegmentsComponent } from '@ebeihilfe/shared';
import { TranslateModule } from '@ngx-translate/core';

import { AsMainStepPipe } from './pipes/as-part-of-main-steps.pipe';
import { SingleStepComponent } from './single-step/single-step.component';

@Component({
  selector: 'portal-einreichung-stepper-with-info',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CircleWithSegmentsComponent, SingleStepComponent, TranslateModule, AsMainStepPipe, AsyncPipe],
})
export class StepperComponent {
  private readonly antragsLimitService = inject(AntragsLimitService);

  public antragsLimit = this.antragsLimitService.getAntragsLimit();
  public currentStep = input.required<EinreichungStep>();
  public einreichungStep = EinreichungStep;
}
